import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getDepositsMovements } from "./../actions/deposits";
// import ReactExport from "react-export-excel";
import Button from '@material-ui/core/Button';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
// import MaterialTable from 'material-table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import { isEmpty } from '../functions/arrays';
import { consolidateDepositsReport } from '../functions/deposits-report';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const DepositsContainer = props => {
    const { classes, getDepositsMovements, secuencial} = props
    const [ depositspaginate, setDepositsPaginate ] = useState([])
    const [ deposits, setDeposits ] = useState(props.deposits)
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    // const [ secuencialAccount, setSecuencialAccount ] = useState(secuencial)
    const [ loading, setLoading ] = useState(false)
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))

    const mount = () => {
        const unmount = () => {
            try {
                moment.locale('es-es')
                let dateStartSend = (dateStart.getFullYear() -1) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
                if (isEmpty(props.deposits)) {
                    handleGetDeposits(dateStartSend, moment(dateEnd).format('YYYY-MM-DD'))
                } else if (props.deposits.info) {
                    if (props.deposits.info.length > 0  ) {
                        handleGetDeposits(dateStartSend, moment(dateEnd).format('YYYY-MM-DD'))
                    }
                }
            } catch (error) {
                //console.log(error)
            }
            
        }
        return unmount()
    }
    useEffect(mount, [])
    // functions
    // SecuencialDeposito, FechaInicio, FechaFin, SecuencialEmpresa
    const handleGetDeposits = (FechaInicio, FechaFin) => {
        getDepositsMovements({SecuencialDeposito: secuencial, FechaInicio, FechaFin, SecuencialEmpresa: 1}).then( res => {
            //console.log(res)
            setDeposits(res.payload.data)
            setLoading(false)
            // setSecuencialAccount(match.params.id)
            filterDepositsByDate(FechaInicio, FechaFin, res.payload.data)
        }).catch( error => {
            //console.log('no se a podido encontrar codes', error)
        })
    }
    // mayor
    const dateAfter = (str1, str2) =>
    {
        return new Date(str1) >= new Date(str2);
    }
    // menor
    const dateBefore = (str1, str2) =>
    {
        return new Date(str1) <= new Date(str2);
    }
    const filterDepositsByDate = (dateStart,  dateEnd, dep) => {
        try {
            const dataResult = dep.filter((deposit) => {
                let dateFormat = moment(deposit.Fecha, 'DD/MM/YYYY').format('YYYY-MM-DD hh:mm:ss')
                if (dateAfter(dateFormat, dateStart) && dateBefore(dateFormat, dateEnd)) {
                    return true
                } else {
                    return false
                }
            })
            getDataViewTableDeposits(dataResult)
            setDeposits(dataResult)
        } catch (error) {
            //console.log('error filterDepositsByDate ', error)
        }
        
    }
    const getDataViewTableDeposits = (deposits) => {
        let dataDepositsPaginate = [];
        let count = parseInt((deposits.length / 5).toString());
        let residuo = deposits.length % 5;

        if(residuo > 0){
            count++;
        }

        if(deposits.length > 0){
            dataDepositsPaginate = deposits.slice(0, 5);
        }
        setDepositsPaginate(dataDepositsPaginate)
        setCount(count)
        setPage(1)
    }
    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleDateEnd = (date) => {
        setDateEnd(date)
    }
    const handleSubmit = (val) => {
        //console.log(val)
    }
    const onChangePaginationDeposits = (e, page) => {
        let init = (page - 1) * 5;
        let end = page * 5;
        let dataDepositsPaginate = [];
        dataDepositsPaginate = deposits.slice(init, end)
        setDepositsPaginate(dataDepositsPaginate)
        setPage(page)
    }

    //render
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (depositspaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            {/* <ExcelFile element={<Button size = { "large"} variant="contained" >Exportar a Excel</Button>} filename = {"Movimientos de Depositos"}>
                                <ExcelSheet data={deposits} name="Movimientos">
                                    <ExcelColumn label="Fecha" value={(col) => moment(col.Fecha).format("YYYY-MM-DD")}/>
                                    <ExcelColumn label="Tipo" value="Transaccion"/>
                                    <ExcelColumn label="Concepto" value="Concepto"/>
                                    <ExcelColumn label="Valor" value="Valor"/>
                                    <ExcelColumn label="Saldo" value="Saldo"/>
                                </ExcelSheet>
                                
                            </ExcelFile> */}
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={ async() => await consolidateDepositsReport(deposits) } >
                                    Exportar a Excel
                            </Button>
                        </Grid>
                        <br />
                        <br />
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha</Th>
                                        <Th>Tipo</Th>
                                        <Th>Concepto</Th>
                                        <Th>Monto</Th>
                                        <Th>Saldo</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        depositspaginate.map(row => (
                                            <Tr key={row.Documento}>
                                                <Td>{ moment(row.Fecha).format("YYYY-MM-DD")}</Td>
                                                <Td>{row.Transaccion}</Td>
                                                <Td>{row.Concepto}</Td>
                                                <Td>$ {row.Valor}</Td>
                                                <Td>$ {row.Saldo}</Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                        </Grid>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationDeposits }
                            />
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }

    const handleSelectDeposit = (val) => {
        try {
            setDateValue(val)
            setLoading(true)
            setDeposits(props.deposits.movements)            
            if (val === 'Todos los movimientos') {
                setLoading(false)
                setDeposits(props.deposits.movements)
                getDataViewTableDeposits(props.deposits.movements);
            } else {
                let obj = JSON.parse(val)
                if (deposits.length > 0) {
                    let selectMonth = new Date(obj.year, obj.month, 1)
                    let dateStart = moment(selectMonth).startOf('month').format('YYYY-MM-DD')
                    let dateEnd = moment(selectMonth).endOf('month').format('YYYY-MM-DD')
                    filterDepositsByDate(dateStart, dateEnd, props.deposits.movements)
                    setDateValue(val)
                    setLoading(false)
                } else {
                    getDataViewTableDeposits(props.deposits.movements)
                    setLoading(false)
                }
            }
        } catch (error) {
            //console.log(error)
        }
        
        
    }
    const handleFindRange = () => {
        try {
            if (deposits.length > 0) {
                filterDepositsByDate(dateStart, dateEnd, props.deposits.movements)
            } else {
                handleGetDeposits(dateStart, dateEnd)
            }
        } catch (error) {
            //console.log(error)
        }
    }
    
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Detalle de Depositos a plazo fijo </Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                        </Grid>
                    </Grid>
                    <SelectForm
                        name = { 'Período' }
                        label = { 'Seleccione período '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectDeposit(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container justify="center" spacing={3}  alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
        </div>
    );
};



DepositsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
}

export default connect(null , { getDepositsMovements })(DepositsContainer);
